import { ServiceSessionUserEvent } from '@modules/ServiceModule';
import { InboxContext } from '../types';
import TasksModule from '@modules/TasksModule';
import { TaskState } from '@modules/TasksModule/types';
import { setCallToAbandoned } from '../callHandlers/callStateHandler';

function handleSessionRescinded(
  context: InboxContext,
  event: ServiceSessionUserEvent,
) {
  const userId = context.userId;
  const eventUserId = event.userId;

  const task = TasksModule.getTaskBySessionSid(event.sessionSid) ?? null;

  // we don't want to handle for other users even if we find the task
  // this could happen if the user makes an outbound via queue
  // and then the queue rollovers
  if (!task || userId !== eventUserId) {
    return;
  }

  if (task.state === TaskState.Offered) {
    // pass task.id, not event.sessionSid: the task may still be keyed by
    // callId, and setCallToAbandoned looks it up again by the id we give it
    setCallToAbandoned({
      context,
      taskId: task.id,
      eventType: 'session-rescinded',
    });
  }
}

export default handleSessionRescinded;
